import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import IPhone18ProBanner from "./banners/iPhone18ProBanner";
import TradeInBanner from "./banners/TradeInBanner";
import InstallmentBanner from "./banners/InstallmentBanner";

import styles from "../HomePage.module.css";
import IPhoneDuoBanner from "./banners/iPhoneDuoBanner";

const BannerSlide = () => {
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={10}
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000 }}
      modules={[Pagination, Autoplay]}
      loop={true}
      className={styles["banner-container"]}
    >
      {/* Slide 1 */}
      <SwiperSlide>
        <IPhone18ProBanner />
      </SwiperSlide>

      {/* Slide 2 */}
      <SwiperSlide>
        <IPhoneDuoBanner />
      </SwiperSlide>

      {/* Slide 3 */}
      <SwiperSlide>
        <TradeInBanner />
      </SwiperSlide>

      {/* Slide 4 */}
      <SwiperSlide>
        <InstallmentBanner />
      </SwiperSlide>
    </Swiper>
  );
};

export default BannerSlide;
